<template>
  <!-- CD-12 ACCOUNT PAYMENT DETAILS -->
  <Dialog :open="open" @update:open="onUpdateOpen">
    <DialogContent
      :class="maxWidth"
      @interact-outside="(e) => preventClose && e.preventDefault()"
      @escape-key-down="(e) => preventClose && e.preventDefault()"
    >
      <DialogHeader>
        <DialogTitle>{{ title }}</DialogTitle>
      </DialogHeader>
      <slot />
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const props = defineProps<{
  open: boolean;
  title: string;
  maxWidth?: string;
  preventClose?: boolean;
}>();

const emit = defineEmits<{
  'update:open': [value: boolean];
}>();

const onUpdateOpen = (value: boolean) => {
  if (!props.preventClose) {
    emit('update:open', value);
  }
};
</script>
